export default __webpack_public_path__ + "static/media/volkswagen-virtus.f73d8b2b.png";